export default __webpack_public_path__ + "static/media/Hospital_3_2.d8caf594.png";